angular.module('unergie.main')
.directive('b2gContacts', ($rootScope, $filter, $timeout, $window, $uibModal, Upload, AlertManager, AccountService, ContactsPaginated, AuthService,
    DataAccessMedias, ModalService, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/csrB2gHome/contacts/b2gContacts.html',
        scope: {},
        link($scope) {
            const nbPerCall = 5
            let nextOffset = 0
            let contactsResultSaved = []
            $scope.lastReached = false
            $scope.isLoadingContact = false
            $scope.contacts = []


            $scope.contactFilterString = {}

            let search = {}

            const transformStatus = {
                'Ouvert': 'open',
                'En attente': 'pending',
                'Résolu': 'resolved',
                'Nouveau': 'new',
                'Fermé': 'closed',
            }

            const filterResult = () => {
                $scope.contacts = _.orderBy($scope.contacts
                .concat(_.map(contactsResultSaved.emails, (email) => {
                    email.technicalStatus = transformStatus[email.status] || email.status
                    email.channel = 'email'
                    email.text = `${email.subject} ${_.map(email.messages, (m) => `${m.commenter} ${m.text}`).join(' ')}`
                    return email
                }))
                .concat(_.map(contactsResultSaved.calls, (call) => {
                    call.channel = 'phone'
                    call.users = _.map(call.users, (user) => `${user.name} (${user.teamName})`).join(', ')

                    return call
                }))
                .concat(_.map(contactsResultSaved.sms, (s) => {
                    s.channel = 'sms'
                    return s
                })), 'updatedAt', 'desc')
            }

            $scope.fetchContacts = (offset = 0) => {
                if (!$scope.isLoadingContact || !offset) {
                    if (!offset) {
                        $scope.contacts = []
                    }
                    $scope.isLoadingContact = true
                    return ContactsPaginated({ offset, limit: nbPerCall }).getContacts(search).$promise.then((result) => {
                        contactsResultSaved = result.toJSON()
                        const nbFetched = Math.max(contactsResultSaved.emails.length, contactsResultSaved.calls.length, contactsResultSaved.sms.length)
                        if (nbFetched < nbPerCall) {
                            $scope.lastReached = true
                        } else {
                            nextOffset += nbPerCall
                        }
                        filterResult()
                    }).catch(ErrorCatcher)
                    .finally(() => {
                        $scope.isLoadingContact = false
                    })
                }
            }

            $scope.refreshContacts = ({ customer_id, mails = [], phones = [] }) => {
                search = {
                    customer_id,
                    mail: mails.join(','),
                }
                const channels = ['email']
                if (phones.length) {
                    channels.push('phone')
                    channels.push('sms')
                    search.phone = phones.join(',')
                }
                search.channel = channels.join(',')
                nextOffset = 0
                $scope.lastReached = false
                $scope.contacts = []
                $scope.fetchContacts()
            }

            $scope.refreshCategoryContacts = (category) => {

            }

            $scope.loadNext = () => {
                if (!$scope.lastReached && !$scope.isLoadingContact) {
                    $scope.fetchContacts(nextOffset)
                }
            }

            $scope.encodeURI = encodeURI

            MetaWatcher.watch('SWITCHED_ACCOUNT_OR_CATEGORY', 'b2gContacts', $scope, $scope.refreshContacts)
        },
    })
)
